var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapability({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.357C7.675 5.357 6.6 4.302 6.6 3H3.4v3.143C2.075 6.143 1 7.198 1 8.5c0 1.302 1.075 2.357 2.4 2.357V14h3.2c0-1.302 1.075-2.357 2.4-2.357s2.4 1.055 2.4 2.357h3.2v-3.143c1.325 0 2.4-1.055 2.4-2.357 0-1.302-1.075-2.357-2.4-2.357V3h-3.2c0 1.302-1.075 2.357-2.4 2.357z",
    stroke: "currentColor",
    strokeWidth: 0.96,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapability);
export default __webpack_public_path__ + "static/media/capability.c4375b32d19f1bddf9e4e850a57bdeee.svg";
export { ForwardRef as ReactComponent };